const base = 'https://api.hair.viewlabs.co/';
const publicV1 = `${base}api/v1/public`;
const privateV1 = `${base}api/v1/private`;

export const environment = {
  production: true,
  licenseKey: 'edc086ba47c5460c0e7931a48bc778dae74419893e37cfb1292a1b472e0621eb1c5f9b828c18a727',
  BASE_REDIRECT: 'https://www.viewlabs.co',
  legalTermsLink: 'https://www.viewlabs.co/legal-terms',
  passwordReset: `${base}accounts/password/reset/`,
  infoEmail: 'info@viewlabs.co',
  privateApi: privateV1,
  publicApi: publicV1,
  apiUrls: {
    auth: `${base}auth/jwt/`,
    userData: '#{}',
    user: `${publicV1}/user/`,
    clinicLead: `${publicV1}/clinic-lead/`,
    clinic: `${publicV1}/clinic/`,
    clinicPrivate: `${privateV1}/clinic/`,
    plan: `${privateV1}/plan/`,
    coupon: `${privateV1}/coupon/`,
    patient: `${publicV1}/patient/`,
    patientsPrivate: `${privateV1}/patients/`,
    imagePrivate: `${privateV1}/image/`,
    image: `${publicV1}/image/`,
    images: `${privateV1}/images/`,
    simulations: `${privateV1}/simulations/`,
    imageData: `${publicV1}/image-mcp/`,
  }
};
